import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Component({
    selector: 'global-policy-priority',
    standalone: false,
    template: `
        <mon-chart-bar
                [height]="235"
                [labels]="chartLabels"
                [data]="chartData"
                [options]="chartOptions"
                [override]="chartOverrides"
                [colors]="barColors">
        </mon-chart-bar>
    `,
})
export class GlobalPolicyPriorityComponent implements OnInit {
    @Input() policies: any;

    chartLabels: any;
    chartData: any;
    chartOptions: any;
    chartOverrides: any;
    barColors: any;

    constructor (private translateService: TranslateService) {}

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.chartLabels = [
            this.translateService.getString('Low'),
            this.translateService.getString('Medium'),
            this.translateService.getString('High'),
        ];
        this.chartData = [
            [
                this.policies.filter((policy: any) => {
                    return policy.priority === 'low' && policy.matches_count > 0;
                }).length,
                this.policies.filter((policy: any) => {
                    return policy.priority === 'medium' && policy.matches_count > 0;
                }).length,
                this.policies.filter((policy: any) => {
                    return policy.priority === 'high' && policy.matches_count > 0;
                }).length,
            ],
        ];
        const max = this.chartData[0].reduce((a: any, b: any) => {
            return Math.max(a, b);
        }, 0);
        this.chartOptions = {
            scales: {
                yAxes: [
                    {
                        id: 'y-axis-0',
                        ticks: {
                            min: 0,
                            max: max * 1.5,
                        },
                        display: false,
                        gridLines: {
                            display: false,
                        },
                    },
                ],
                xAxes: [
                    {
                        barPercentage: 1,
                        categoryPercentage: 0.5,
                        gridLines: {
                            display: false,
                            drawBorder: false,
                        },
                        ticks: {
                            fontColor: '#a6a6a6',
                            fontSize: 11,
                        },
                    },
                ],
            },
            drawLabelOnChart: true,
        };

        this.barColors = ['#a8d6f3', '#a8d6f3', '#a8d6f3'];

        this.chartOverrides = [
            {
                borderWidth: 0,
                backgroundColor: 'rgba(54, 162, 235, 0.5)',
            },
        ];
    }
}
